// Edit layer style rule: Custom component to edit a COLOR setting

import { Box, Stack, Typography } from '@mui/material';
import { theme_errorRed, theme_orange, theme_textColorBlended, theme_textColorMain } from '../../../Theme';
import { MuiColorInputStyled } from '../EditLayerStyle';



//-------------------------------------------------------------------------------
// Component props
//-------------------------------------------------------------------------------
export interface EditLayerStyleRule_Setting_Color_Props
{
  name: string;
  name_font_size: string;
  value: string;
  default_value: string;
  is_default_rule: boolean;
  OnChangeHandler: any;
  margin_left?: number;
  width?: string;
}

//-------------------------------------------------------------------------------
// Edit layer style rule: Custom component to edit a COLOR setting
//-------------------------------------------------------------------------------
export function EditLayerStyleRule_Setting_Color(props: EditLayerStyleRule_Setting_Color_Props) 
{








  

  // Main render

  return (

    <Stack sx={{ ml: props.margin_left }}>
      <Typography sx={{ fontSize: props.name_font_size, color: theme_textColorBlended+'B0' }}>
        {props.name}
      </Typography>                
      <MuiColorInputStyled variant='standard' size='small' format='hex' isAlphaHidden={true}
                           value={props.value} 
                           onChange={props.OnChangeHandler}
                           sx={{ width: props.width }}/>
      {RenderDefaultValue_Color(props.value, props.default_value, props.is_default_rule)}
    </Stack>
  )
}





//-------------------------------------------------------------------------------
// Renders the default color value/status.
//-------------------------------------------------------------------------------
export function RenderDefaultValue_Color(value: string, value_default: string, is_default_rule: boolean)
{
  // If the value is set, or if this is happening inside the "Default Rule", we show nothing
  if(value.length > 0 || is_default_rule===true)
    return null;

  return (

    <Stack direction='row' sx={{ alignItems: 'center' }}>

      <Typography sx={{ fontSize: '0.7rem', color: theme_textColorMain+'70'}}>
        Default:
      </Typography>

      {value_default
        ?
          // We have a default value - show it
          <Stack direction='row' sx={{ ml: 0.5, alignItems: 'center' }}>
            <Box sx={{ width: '15px', height: '12px', borderRadius: 1, bgcolor: value_default, border: 1, borderColor: theme_textColorBlended+'A0' }}/>
            <Typography sx={{ ml: 0.6, fontSize: '0.7rem', color: theme_orange+'A0'}}>
              {value_default}
            </Typography>
          </Stack>
        : // No default value is set - show a warning
          <Typography sx={{ ml: 0.5, fontSize: '0.7rem', color: theme_errorRed}}>
            Not set
          </Typography>
      }

    </Stack>      
  )
}